export default "__VITE_ASSET__CIyQJwSd__"